import { createRoute } from '@tanstack/react-router';
import { tourConfigRoute } from '@/features/dashboard/tourConfig/routes/tourConfigRoutes.ts';
import TourInsurancesConfigPage from '@/features/dashboard/tourInsurances/pages/TourInsurancesConfigPage.tsx';

export const tourInsurancesConfigRoute = createRoute({
  getParentRoute: () => tourConfigRoute,
  path: 'insurances',
  component: TourInsurancesConfigPage,
});
